/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'GoalLinker.error.generic.description': 'Zkontrolujte připojení k internetu a zkuste to znovu.',
  'GoalLinker.error.generic.header': 'Něco se pokazilo',
  'GoalLinker.error.linking.header': 'Připojení cíle se nezdařilo',
  'GoalLinker.error.max-entities-to-goal.description':
    'Entit typu {entities} lze k cíli připojit maximálně 100. Chcete-li přidat další entity typu {entities}, odeberte některou z entit typu {entity}.',
  'GoalLinker.error.max-entities-to-goal.header': 'Dosáhli jste limitu 100 entit typu {entity}',
  'GoalLinker.error.max-goals.description':
    'Připojit jde maximálně 100 cílů. Chcete-li přidat další cíle, odeberte některé z připojených.',
  'GoalLinker.error.max-goals.header': 'Dosáhli jste limitu 100 cílů',
  'GoalLinker.goal-row.open-goal': 'Otevřít cíl',
  'GoalLinker.link-goals.error-description': 'Něco se pokazilo, zkontrolujte připojení k internetu a zkuste to znovu.',
  'GoalLinker.link-goals.error-title': 'Odpojení cíle se nezdařilo.',
  'GoalLinker.linked-goals.header': 'Připojené cíle',
  'GoalLinker.linked-goals.show-less': 'Zobrazit méně',
  'GoalLinker.linked-goals.show-more': 'Zobrazit další ({count})',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'Propojte své nápady s cíli a sledujte, jak práce přispívá k výsledkům.',
  'GoalLinker.recents.emptystate-project.description':
    'Propojte svůj projekt s cíli a sledujte, jak se práce posouvá k výsledkům.',
  'GoalLinker.recents.emptystate.description':
    'Propojte své požadavky s cíli a sledujte, jak se práce posouvá k výsledkům.',
  'GoalLinker.recents.emptystate.header': 'Začínáme s cíli',
  'GoalLinker.recents.header': 'Nedávné cíle',
  'GoalLinker.search.emptystate.description': 'Zkuste zkontrolovat překlepy.',
  'GoalLinker.search.emptystate.header': 'Žádné odpovídající výsledky',
  'GoalLinker.search.label': 'Výsledky',
  'GoalLinker.search.placeholder': 'Vyhledejte cíle nebo vložte odkaz.',
};
